export interface TimestampTzDatatypeInterface extends Date {
  data?: Date;
}

export class TimestampTzDatatypeClass extends String {
  data?: Date;
}
